<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardConver
            :content="content"
            :checkWidth="widthScreen"
            @nextRoute="nextRoute"
          />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardConver from "../../components/template/Chinese1/CardConver";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardConver, LoadingMDL },
  name: "CTT02",
  data() {
    return {
      content: {},
      widthScreen: window.innerWidth.toString(),
      lang: this.$store.getters["language/getLanguage"],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      pageCode: "",
      CheckWidth: window.innerWidth.toString(),
      courseCode: "",
      topicId: "",
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: "",
      startTime: "",
      condition: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']

        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    getUserTemplate: function(val) {
      this.condition =
        typeof val.data.condition.criteriaType == "undefined" ||
        val.data.condition.criteriaType.length == 0
          ? []
          : [
              {
                criteria: val.data.condition.criteriaType[0].criteria._id,
                val: val.data.condition.criteriaType[0].val,
              },
            ];
      this.userTemplateData = val;
      this.loading = false;
    },
    loadingGetter: function(val) {
      if (val == true) {
        this.$router.push(this.nextAction);
      }
    },
  },

  mounted() {},

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `CTT02-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    nextRoute(val) {
      let str = val.split("-");
      // this.$router.push("/" + str[0] + "/" + str[1]);
      const useTime = this.$helpers.getUseTime();
      // this.userTemplateData.template = this.$helpers.setUserCriteria(
      //   this.userTemplateData.template,
      //   useTime
      // );
      // if (this.userTemplateData.quiz.length !== 0) {
      //   this.userTemplateData.quiz = this.$helpers.setUserQuizScore(
      //     this.userTemplateData.quiz,
      //     this.score
      //   );
      // }
      this.nextAction = "/" + str[0] + "/" + str[1];
      /*
      this.$store.dispatch(
        "template/saveUserTemplateData",
        this.userTemplateData
      );
      */
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
  },
};
</script>
<style></style>
